<template>
  <div class="row">
    <div class="name">
      {{ item.quantity }}x <strong>{{ item.title }}</strong>
    </div>
    <div class="price">
      {{ item.piece_price | currency }}
    </div>
    <div class="action">
      <a href="#" @click.prevent="removeFromCart({id: item.id, quantity: item.quantity})">
        <i class="icon-trash" />
      </a>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(['removeFromCart']),
  },
};
</script>
